import type { CopyAndImageProps as Props } from './types';
import { withChildren } from '@builder.io/react';
import { useColorProvider } from '@/utils/ColorProvider';
import { TextAlignmentOptions, HeroImagePlacements } from '@/constants';
import RichText from '@/components/RichText';
import { cls } from '@/utils/cls';
import style from './CopyAndImage.module.scss';
import Image from 'next/image';
export function CopyAndImage({
  extendStyles,
  heading,
  headingAlignment = TextAlignmentOptions.LEFT,
  copy,
  copyAlignment = TextAlignmentOptions.LEFT,
  image,
  color,
  line,
  children,
  textSide = HeroImagePlacements.LEFT,
  listColumns = false,
  mobileImage = true,
  headingSpan = false
}: Props) {
  const _className = cls(style.root, extendStyles);
  const {
    colors
  } = useColorProvider();
  const textLeft = textSide === TextAlignmentOptions.LEFT;
  const textStyles = cls(style.text, textLeft ? style.left : style.right);
  const imageStyles = cls(style.wrapper, textLeft ? style.right : style.left, headingSpan ? style.square : '');
  const copyStyles = cls(style.copy, listColumns ? style.cols : '');
  const wrapperStyles = cls(style.mobileWrapper, !mobileImage ? style.mobileHide : '', headingSpan ? style.square : '');
  const imageSrc = typeof image === 'string' ? image : image?.src;
  const squareSize = {
    width: 320,
    height: 320
  };
  const normalSize = {
    width: 600,
    height: 400
  };
  const imageSize = headingSpan ? squareSize : normalSize;
  return <section className={_className} style={{
    backgroundColor: color || '#F9FAFB'
  }} data-sentry-component="CopyAndImage" data-sentry-source-file="CopyAndImage.tsx">
			<div className={style.content} data-grid>
				{heading && headingSpan && <RichText text={heading} className={cls(style.heading, !!line ? style.hr : '')} style={{
        borderColor: colors.secondaryAccentColor
      }} data-align={headingAlignment} />}
				<div className={textStyles}>
					{heading && !headingSpan && <RichText text={heading} className={!!line ? style.hr : ''} style={{
          borderColor: colors.secondaryAccentColor
        }} data-align={headingAlignment} />}
					{imageSrc && <div className={wrapperStyles}>
							<Image className={style.image} src={imageSrc} alt="" role="presentation" width={imageSize.width} height={imageSize.height} />
						</div>}
					{copy && <RichText text={copy} className={copyStyles} style={{
          borderColor: colors.secondaryAccentColor
        }} data-align={copyAlignment} />}
					{children}
				</div>

				{imageSrc && <div className={imageStyles}>
						<Image className={style.image} src={imageSrc} alt="" role="presentation" width={imageSize.width} height={imageSize.height} />
					</div>}
			</div>
		</section>;
}
export default withChildren(CopyAndImage);